var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37510",
    "data-name": "Group 37510",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3032",
    "data-name": "Rectangle 3032",
    width: 32,
    height: 32,
    rx: 8,
    fill: "#bdc3d0",
    opacity: 0.242
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42931",
    "data-name": "Group 42931",
    transform: "translate(-13.848 -131.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_0",
    transform: "translate(21.401 138.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40692",
    "data-name": "Path 40692",
    d: "M14.653,19A3.016,3.016,0,1,1,8.62,19H5v1.207a.6.6,0,0,0,.6.6h.918a5.6,5.6,0,0,0,.218.527l-.649.65a.6.6,0,0,0,0,.853L7.8,24.546a.6.6,0,0,0,.853,0L9.3,23.9a5.486,5.486,0,0,0,.527.218v.918a.6.6,0,0,0,.6.6h2.413a.6.6,0,0,0,.6-.6v-.918a5.486,5.486,0,0,0,.527-.218l.65.649a.6.6,0,0,0,.853,0l1.706-1.706a.6.6,0,0,0,0-.853l-.649-.65a5.6,5.6,0,0,0,.218-.527h.918a.6.6,0,0,0,.6-.6V19Z",
    transform: "translate(-3.19 -8.141)",
    fill: "#1a49a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40693",
    "data-name": "Path 40693",
    d: "M13.675,20.675A1.675,1.675,0,0,0,15.349,19H12A1.675,1.675,0,0,0,13.675,20.675Z",
    transform: "translate(-5.228 -8.141)",
    fill: "#1a49a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40694",
    "data-name": "Path 40694",
    d: "M18.289,10.446H15.876V6.223L13.463,5.016v5.43h-.6V3.207L10.446,2,8.033,3.207v7.24h-.6V5.016L5.016,6.223v4.223H2.6a.6.6,0,1,0,0,1.207H18.289a.6.6,0,1,0,0-1.207ZM14.066,7.128a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3v.6a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3Zm0,2.413v-.6a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3v.6a.3.3,0,0,1-.3.3h-.6A.3.3,0,0,1,14.066,9.541ZM11.049,4.715a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3V5.921a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3Zm0,2.413a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3V8.335a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3ZM8.636,4.715a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3V5.921a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3Zm0,2.413a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3V8.335a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3ZM9.843,9.263h1.134a.3.3,0,0,1,.3.3v.882H9.541V9.565A.3.3,0,0,1,9.843,9.263ZM5.62,7.128a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3v.6a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3Zm0,2.413v-.6a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3v.6a.3.3,0,0,1-.3.3h-.6A.3.3,0,0,1,5.62,9.541Z",
    transform: "translate(-2 -2)",
    fill: "#1a49a3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyWithBg);
export default __webpack_public_path__ + "static/media/companyWithBg.50727f4df9ad0726df9aed8d29b53910.svg";
export { ForwardRef as ReactComponent };